/** @jsxImportSource @emotion/react */
import { AppBar,Toolbar, Typography } from '@mui/material';
import { css } from '@emotion/react'
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { styled } from '@mui/material/styles';
import NiedersachsenTopbar from '../NiedersachsenTopbar/NiedersachsenTopbar';
import LoginButton from '../LoginButton';
import { useTypedSelector } from '../../reducers';
import { Link } from 'react-router-dom'
import { useCallback } from 'react';
import MikeButton from '../mike-button';

const secondTopbarStyle = css`
  background-color: ${mikeSharedTheme.palette.common.white}; 
  height: 60px;
  width: 100vw;
  display: flex;
  justify-content: space-between
`;

const leftSection = css`
 justify-content: start;
  display: flex;
  align-items: center;
  padding-right: ${mikeSharedTheme.spacing(1)};
`;

const rightSection = css`
  
  display: flex;
  justify-content: end;
  padding-left: ${mikeSharedTheme.spacing(1)};
`;

const middleSection = css`
  display: flex;    
  justify-content: center; 
  align-items: center; 
`;

const mikeTopbarAppTitleStyle = css`
  white-space: nowrap;
  min-height: 60;
  color: ${mikeSharedTheme.palette.text.primary};
  margin-top: ${mikeSharedTheme.spacing(-0.5)};  
  text-overflow: ellipsis;  
max-width: 45vw;
`;

const buttonStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding-right: ${mikeSharedTheme.spacing(1)};
  padding-left: ${mikeSharedTheme.spacing(1)};
`;

const buttonsContainerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const linkStyle = css`
  display: content;
  text-decoration: none;
`;

const placeHolderStyle = css`
  width: ${mikeSharedTheme.spacing(1)};
`;


const StyledToolbar = styled(Toolbar)(() => ({
  alignItems: 'flex-start',
  flexDirection: 'column',
  height: '60px',
  '@media all': {
    minHeight: 60,
  },
}));

export const Topbar = () => {
  const user = useTypedSelector((state) => state.auth.user);
   const config = useTypedSelector((state) => state.auth.config); 
  
  const handleDownLoadUserManual =  useCallback(() => {
    if (config && config.backendUrl){
      const url = config.backendUrl + "api/File/UserManual";
      window.open(url, "_self");
    }  
  }, [config])
  return (
    <AppBar position="fixed" elevation={0}>
      <StyledToolbar disableGutters={true}>             
        <div css={secondTopbarStyle}> 
          <div css={leftSection}><NiedersachsenTopbar/> </div>  
          <div css={middleSection}>
            <Typography variant="h3" css={mikeTopbarAppTitleStyle}>
              <b>{"EG-HWRM-RL: Maßnahmen-Erfassung"}</b>
            </Typography>  
          </div> 
          <div css={rightSection}>
            <div css={buttonsContainerStyle}>  
              <MikeButton variant="contained" onClick={handleDownLoadUserManual}>{"Bedienungsanleitung"}</MikeButton> 
              <div css={placeHolderStyle}/>           
              <Link css={linkStyle} to={"/impressum"}><Typography variant="body2">{"Impressum"}</Typography> </Link>
              <div css={placeHolderStyle}/>
              <Link css={linkStyle} to={"/datenschutz"}><Typography variant="body2">{"Datenschutz"}</Typography> </Link>              
              {user ? <div css={buttonStyle}><LoginButton/></div> : <div css={placeHolderStyle}/>  }
            </div>   
          </div>   
        </div>       
      </StyledToolbar>
    </AppBar>
  );
};

export default Topbar;
